import { cdataFetch } from "src/api/cdataFetch";

type GetIsAccountUsingSSOParams = {
  disableImpersonation?: boolean;
};

export function getIsAccountUsingSSO(params: GetIsAccountUsingSSOParams = {}) {
  const { disableImpersonation = false } = params;

  return cdataFetch<boolean>({
    method: "GET",
    url: "/account/isAccountUsingSSO",
    disableImpersonation,
  });
}
